import React from 'react'
import ProfileForm from 'components/Common/ProfileForm'
import { AppFC, ICreateProfile } from 'types'

const CreateProfile: AppFC<ICreateProfile> = ({
  userId,
  moveToNext,
  handleBack,
  activeStep,
  updateProgressbarAction,
  updateUserProfileAction,
  updateUserBusinessProfileAction,
}) => {
  const updateUserData = (data) => {
    updateUserProfileAction({
      ...data.profileData,
    })
    updateUserBusinessProfileAction({
      businessName: data.businessData.businessName,
      id: userId,
    })
    moveToNext()
  }
  return (
    <>
      <ProfileForm
        onSubmit={(data) => {
          updateUserData(data)
          updateProgressbarAction()
        }}
        handleBack={() => handleBack(activeStep)}
        headerStyle="text-left"
        fontStyle="font-secondary"
        heading="Confirm your details"
        type="initial assessment"
      />
    </>
  )
}

export default CreateProfile
